import React from 'react';
import PropTypes from 'prop-types';
import WeekViewCalendar from './weekly/WeekViewCalendar';

const WeeklyView = ({ noClSheets }) => {

  return (
    <WeekViewCalendar
      noClSheets={noClSheets}
    />
  );
};

WeeklyView.propTypes = {
  noClSheets: PropTypes.arrayOf(PropTypes.string),
};

export default WeeklyView;

